import { render, staticRenderFns } from "./SimpleTables.vue?vue&type=template&id=74c37930&"
import script from "./SimpleTables.vue?vue&type=script&lang=js&"
export * from "./SimpleTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports